import { useMemo } from 'react'

import {
  useCreateEoJPromotionMutation,
  useCreateValidationRulesMutation,
  useListValidationRulesQuery,
  ListValidationRulesDocument,
  ListCampaignsDocument,
  useListMetadataSchemasQuery,
  type MetadataSchemaObjectType,
  type ListMetadataSchemasQuery_metadata_schemas_MetadataSchemaConnection_nodes_MetadataSchemaItem,
} from '~/gql/generated/graphql'

type MetadataSchemaItem =
  ListMetadataSchemasQuery_metadata_schemas_MetadataSchemaConnection_nodes_MetadataSchemaItem

export const useCreatePromotion = () => {
  const [createPromotion, { loading: saving, error }] =
    useCreateEoJPromotionMutation({
      refetchQueries: [ListCampaignsDocument],
    })
  return { createPromotion, saving, error }
}

export type ValidationRuleOption = {
  label: string
  value: string
}
export const useValidationRules = () => {
  const { data, loading } = useListValidationRulesQuery({ pollInterval: 0 })
  const rules = useMemo(
    () =>
      data?.table.nodes.map(item => ({
        label: item.name,
        value: item.id,
      })) ?? [],
    [data?.table],
  )

  const [createValidationRules, { loading: saving }] =
    useCreateValidationRulesMutation({
      refetchQueries: [ListValidationRulesDocument],
    })

  return { loading, rules, createValidationRules, saving }
}

export const useMetadataSchemaOptions = () => {
  const { data, loading } = useListMetadataSchemasQuery({
    pollInterval: 0,
    fetchPolicy: 'cache-first',
  })

  // This result comes as a list [{related_object: cutomer, ...data}] so grouping by these
  // expected keys for lookup {customer: data, ...}
  const metadataSchemas = data?.metadata_schemas.nodes.reduce(
    (acc, item) => {
      return { ...acc, [item.related_object]: item }
    },
    {} as Record<MetadataSchemaObjectType, MetadataSchemaItem>,
  )

  return {
    metadataSchemas,
    loading,
  }
}
